import React from 'react'
import { enableNotifications } from '@app/lib'
import { GrNotification } from 'react-icons/gr'
import { Button } from '../general'
import { useInteractiveContext } from '../providers/interactive'
import { ModalType } from '@app/data/enums'
import { useTranslation } from '@app/lib/hooks/useTranslation'
import { dialogDescriptionID, dialogID } from '../modal/headless'
import { Dialog } from '@headlessui/react'

export function EnableNotifications() {
  const { setModal } = useInteractiveContext()
  const { t } = useTranslation('dashboard-modal')

  const onOkPressEvent = () => {
    setModal({ open: false, modalType: ModalType.empty, url: '' })
    enableNotifications()
  }

  const onNotNowEvent = () =>
    setModal({ open: false, modalType: ModalType.empty, url: '' })

  return (
    <div className={'px-4 py-4 space-y-4'}>
      <div className='space-y-3'>
        <GrNotification fontSize='large' className='grIcon' />
        <Dialog.Title id={dialogID} className='xl:text-xl'>
          {t('alerts.enableNotificationsTitle')}
        </Dialog.Title>
        <Dialog.Description className={`text-sm pb-2`} id={dialogDescriptionID}>
          {t('alerts.enableNotificationsDetail')}
        </Dialog.Description>
      </div>
      <div className='space-x-3'>
        <Button
          className={'bg-transparent border-0 hover:opacity-80'}
          onClick={onNotNowEvent}
        >
          {t('not-now')}
        </Button>
        <Button
          onClick={onOkPressEvent}
          border={false}
          className={`border border-blue-700 text-blue-600 hover:opacity-80`}
        >
          {t('ok')}
        </Button>
      </div>
    </div>
  )
}
